import React, { createContext, useState, useEffect } from "react";

export const TrackingContext = createContext();
const { Provider } = TrackingContext;

const initialValues = JSON.parse(localStorage.getItem("tracking"))
  ? JSON.parse(localStorage.getItem("tracking"))
  : {
      topicName: "",
      subtopicName: "",
      sonPosition: 0,
      id: 0,
      fatherPosition: 0,
      fatherIsPlayingVal: 0,
    };

const TrackingProvider = ({ children }) => {
  const {
    topicName,
    subtopicName,
    sonPosition,
    id,
    fatherPosition,
    fatherIsPlayingVal,
  } = initialValues;

  const [topicActiv, setTopicActiv] = useState({ topicName, subtopicName });
  const [isPlaying, setIsPlaying] = useState({
    id,
    sonPosition,
    fatherPosition,
  });

  const [fatherIsPlaying, setFatherIsPlaying] = useState({
    fatherIsPlayingVal,
  });
  const [currenteCourse, setCurrenteCourse] = useState(
    localStorage.getItem("currentCourse")
  );

  const [currentNameCourse, setCurrentNameCourse] = useState("");

  const updateTopic = (data) => {
    setTopicActiv(data);
    updateLocalStorage(data);
  };

  const updatePlaying = (data) => {
    setIsPlaying(data);
    updateLocalStorage(data);
  };

  const updateFather = (data) => {
    setFatherIsPlaying(data);
    updateLocalStorage(data);
  };

  const updateStates = (initialValues) => {
    const subtopicName =
      initialValues.topics[0].subtopics.length > 0
        ? initialValues.topics[0].subtopics[0].name
        : "";
    const subtopicId =
      initialValues.topics[0].subtopics.length > 0
        ? initialValues.topics[0].subtopics[0].id
        : initialValues.topics[0].id;
    updateTopic({
      courseId: initialValues.id,
      topicName: initialValues.topics[0].name,
      subtopicName,
    });
    updatePlaying({
      courseId: initialValues.id,
      id: subtopicId,
      sonPosition: 0,
      fatherPosition: 0,
    });
    updateFather({
      courseId: initialValues.id,
      fatherIsPlayingVal: 0,
    });
  };

  const updateLocalStorage = (data) => {
    const localData = JSON.parse(localStorage.getItem("tracking"));
    if (localData !== undefined && localData !== null) {
      let pos = localData.findIndex((item) => item.courseId === data.courseId);
      if (pos !== -1) {
        let course = localData[pos];
        course = {
          ...course,
          ...data,
        };
        localData[pos] = course;
      } else {
        localData.push(data);
      }

      localStorage.setItem("tracking", JSON.stringify(localData));
    } else {
      localStorage.setItem("tracking", JSON.stringify([data]));
    }
    activeCourse(currenteCourse);
  };

  const activeCourse = (courseId) => {
    let coursesInLocal = JSON.parse(localStorage.getItem("tracking"));
    if (coursesInLocal) {
      const active = coursesInLocal?.filter(
        (item) => item.courseId === courseId
      );
      if (active.length > 0) {
        setTopicActiv({
          courseId: courseId,
          topicName: active[0].topicName,
          subtopicName: active[0].subtopicName,
        });
        setIsPlaying({
          courseId: courseId,
          id: active[0].id,
          sonPosition: active[0].sonPosition,
          fatherPosition: active[0].fatherPosition,
        });
        setFatherIsPlaying({
          courseId: courseId,
          fatherIsPlayingVal: active[0].fatherIsPlayingVal,
        });
      }
    }
  };

  const ValidateLocalInitial = (initialValues) => {
    let coursesInLocal = JSON.parse(localStorage.getItem("tracking"));
    if (coursesInLocal) {
      const findCourse = coursesInLocal.findIndex(
        (course) => course.courseId === initialValues.id
      );
      if (findCourse === -1) {
        updateStates(initialValues);
      }
    } else {
      updateStates(initialValues);
    }
  };

  useEffect(() => {
    if (currenteCourse !== null) {
      activeCourse(currenteCourse);
    }
    // eslint-disable-next-line
  }, [initialValues, currenteCourse]);

  return (
    <Provider
      value={{
        topicActiv,
        isPlaying,
        fatherIsPlaying,
        updateTopic,
        updatePlaying,
        updateFather,
        activeCourse,
        setCurrenteCourse,
        ValidateLocalInitial,
        setCurrentNameCourse,
        currenteCourse,
        currentNameCourse,
      }}
    >
      {children}
    </Provider>
  );
};

export default TrackingProvider;
